
import "@sparta.accessible-banking.modules/services-resources-list-module/dist/styles.css"
import "@sparta.accessible-banking.modules/banking-by-mail-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js"
import phoneLinkUtility from "@sparta.sales.utilities/phone-link-utility/dist/es5.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es5.js"

import "@sparta.accessible-banking.modules/services-resources-list-module/dist/es5.js"
import "@sparta.accessible-banking.modules/banking-by-mail-module/dist/es5.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  var bootExecs = [];
  bootExecs.push(function() { return spartaBootstrapUtility.init(arguments); });
  bootExecs.push(function() { return phoneLinkUtility.run(arguments); });
  bootExecs.reduce(function(cur, next) {
    return cur.then(next);
  }, Promise.resolve()).then(function() {
    console.log('after - execute boot functions')
  });
})();
